import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getTransactionCategoriesInput,
  getTransactionCategoryInput,
  TransactionCategoryLiteModel,
  TransactionCategoryModel,
} from './model';

export const transactionCategoryKeys = {
  index: (input?: getTransactionCategoriesInput) =>
    ['getTransactionCategories', input?.params].filter(Boolean),
  view: (input?: getTransactionCategoryInput) =>
    ['getTransactionCategory', input?.id].filter(Boolean),
};

export function useGetTransactionCategories(
  input?: getTransactionCategoriesInput,
  options?: UseQueryOptions<
    ExtendedApiResult<TransactionCategoryLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<TransactionCategoryLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? transactionCategoryKeys.index(input),
      () =>
        QueryFetchFunction({
          url: 'transaction-categories',
          params: input?.params,
        }),
      options,
    ),
    TransactionCategoryLiteModel,
  );
}

export function useGetTransactionCategory(
  input?: getTransactionCategoryInput,
  options?: UseQueryOptions<ApiResult<TransactionCategoryModel>, ApiError>,
): UseQueryResult<ApiResult<TransactionCategoryModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? transactionCategoryKeys.view(input),
      () =>
        QueryFetchFunction({
          url: `transaction-categories/${input?.id}`,
        }),
      options,
    ),
    TransactionCategoryModel,
  );
}
